export default __webpack_public_path__ + "static/O0207-2814b98f0794a0aca102e8016ac349e6.png";